import { Box, Typography, useMediaQuery } from '@mui/material'
import React from 'react'

import CustomModal from '../../../../Theme/Modal'
import { BREAKPOINT_MIN_SM } from '../../../../Theme/stylesUtil'
import PrefabRatingIconsWrapper from './PrefabRatingIconsWrapper'

const PrefabRatingModal = ({ isOpenModal, handleCloseModal, rating, setRating, handleSavePrefabRating }) => {
  const isBiggerThanSMScreen = useMediaQuery(BREAKPOINT_MIN_SM)
  const handleMouseMove = (event) => {
    const boundingRect = event.currentTarget.getBoundingClientRect()
    const mouseX = isBiggerThanSMScreen && event.clientX - boundingRect.left
    const touchX = !isBiggerThanSMScreen && event.touches[0].clientX - boundingRect.left
    const totalWidth = boundingRect.width
    const starWidth = totalWidth / 5
    const newHoverRating = mouseX && Math.ceil((mouseX / starWidth) * 2) / 2
    const newTouchRating = touchX && Math.ceil((touchX / starWidth) * 2) / 2

    setRating((prevState) => {
      if (isBiggerThanSMScreen) {
        if (newHoverRating > 0 && newHoverRating <= 5) {
          return newHoverRating
        } else {
          return prevState
        }
      } else {
        if (newTouchRating > 0 && newTouchRating <= 5) {
          return newTouchRating
        } else {
          return prevState
        }
      }
    })
  }

  const handleSaveRatingResult = () => {
    handleSavePrefabRating(rating)
    handleCloseModal()
  }
  const handleTouchStart = (event) => {
    if (isBiggerThanSMScreen) return
    handleMouseMove(event)
  }

  const onMouseMove = (event) => {
    if (!isBiggerThanSMScreen) return
    handleMouseMove(event)
  }

  const onTouchMove = (event) => {
    if (isBiggerThanSMScreen) return
    handleMouseMove(event)
  }

  return (
    <CustomModal
      width={isBiggerThanSMScreen ? '424px' : '265px'}
      open={isOpenModal}
      onClose={handleCloseModal}
      cancelText={'Cancel'}
      okText={'Save'}
      onOk={handleSaveRatingResult}
      header={
        <Typography
          variant="h4"
          color="text.primary"
        >
          Rate Prefab
          <Box
            component="span"
            sx={(theme) => ({ color: theme.palette.text.tertiary, marginLeft: '10px', fontSize: '12px' })}
          >
            {rating || 0} {rating === 1 ? 'star' : 'stars'}
          </Box>
        </Typography>
      }
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '5px',
          width: 'auto',
          margin: '0 auto',
        }}
        onMouseMove={onMouseMove}
        onTouchStart={handleTouchStart}
        onTouchMove={onTouchMove}
      >
        <PrefabRatingIconsWrapper
          rating={rating}
          isDynamicIcon={true}
          length={5}
          size={35}
        />
      </Box>
      <Typography
        variant="body2"
        color="text.primary"
        sx={{ padding: '10px' }}
      >
        Do you want to give this prefab a {rating} rating?
      </Typography>
    </CustomModal>
  )
}

export default PrefabRatingModal
